import React, {Component} from 'react'
import './styles.scss';

class Button extends Component {
    render() {
        let className = "Button";
        if (this.props.default) className += " default";
        return (<a className={className} onClick={this.props.onClick}>
            {this.props.text}
        </a>);
    }
}

export default Button;



// WEBPACK FOOTER //
// ./src/components/bobtv-neo/UIKit/Button/index.js